import { render, staticRenderFns } from "./pagevisit.vue?vue&type=template&id=2d9ccb05&scoped=true&"
import script from "./pagevisit.vue?vue&type=script&lang=js&"
export * from "./pagevisit.vue?vue&type=script&lang=js&"
import style0 from "./pagevisit.vue?vue&type=style&index=0&id=2d9ccb05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ccb05",
  null
  
)

export default component.exports